import styled from "styled-components";

// tslint:disable-next-line
export const ActionMenuSelectMultipleAvailable = styled.select`
  min-width: 250px;
  min-height: 250px;
  margin-top: 5px;
  margin-bottom: 5px;
`;
